/** @jsxImportSource @emotion/react */
import { useState, useEffect } from "react";
import { accessAPI, Titulo } from "../../shared";
import TarjetaPaso from "./TarjetaPaso";

// Pasos de actividad abiertos que el administrador tiene asignados. La sección
// solo aparece si tiene alguno.
export default function MisPasos({ toast }) {
  const [pasos, setPasos] = useState([]);

  useEffect(() => {
    accessAPI(
      "GET",
      "admin/mispasos",
      null,
      (respuesta) => setPasos(respuesta),
      (error) =>
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: error?.[0]?.msg || "No se pudieron cargar tus pasos.",
          sticky: true
        })
    );
  }, [toast]);

  if (pasos.length === 0) return null;

  return (
    <div css={{ marginBottom: "1.5em" }}>
      <Titulo>Mis pasos</Titulo>
      <div className="grid">
        {pasos.map((paso) => (
          <TarjetaPaso key={paso.id} paso={paso} />
        ))}
      </div>
    </div>
  );
}
